import { Link } from 'react-router-dom';
import { allCategories } from '@/utils/data';

const accentMap: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700' },
};

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 py-10 md:px-8 md:py-12">
      <div className="flex snap-x gap-3 overflow-x-auto pb-2 no-scrollbar md:grid md:grid-cols-4 md:gap-5 md:overflow-visible">
        {allCategories.map((c) => {
          const tone = accentMap[c.accent] || accentMap.primary;
          return (
            <Link
              key={c.id}
              to={`/category/${c.slug}`}
              className="group flex w-64 shrink-0 snap-start items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 md:w-auto md:flex-col md:items-start md:gap-3 md:p-5 cursor-pointer"
            >
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md ${tone.bg} ${tone.text}`}>
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <div className="min-w-0 md:w-full">
                <h3 className="flex items-center gap-1 text-base font-semibold text-foreground-900 group-hover:text-primary-600">
                  {c.name}
                  <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5"></i>
                </h3>
                <p className="mt-1 line-clamp-2 text-xs text-foreground-500">{c.desc}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}